<template>
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM12.0303 6.53033C12.3232 6.23744 12.3232 5.76256 12.0303 5.46967C11.7374 5.17678 11.2626 5.17678 10.9697 5.46967L7 9.43934L5.03033 7.46967C4.73744 7.17678 4.26256 7.17678 3.96967 7.46967C3.67678 7.76256 3.67678 8.23744 3.96967 8.53033L6.46967 11.0303C6.76256 11.3232 7.23744 11.3232 7.53033 11.0303L12.0303 6.53033Z"
    fill="currentColor" />
</template>
